import React, { useEffect, useState } from "react";
import {
  Dialog,
  makeStyles,
  useMediaQuery,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import axios from "axios";
import { GetAllBillsAPI, GetAllChallansAPI, GetAllDebitsAPI, GetAllPurchasesAPI } from "../../config/api";
import DateUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { useSelector } from "react-redux";
import { pointToPointBillTemplate } from "../../assets/html/pointToPointBillTemplate.js";
import { dataURItoBlob, htmlTemplateToDataString } from "../../utils/index.js";
import { pointToPointTemplate } from "../../assets/html/pointToPointTemplate.js";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    fontSize: "14px",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    fontWeight: "300",
    marginBottom: "3px",
  },
});

export default function PointToPoint(props) {
  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const {
    PTPType,
    openPTPTypeSelectionDialog,
    setOpenPTPTypeSelectionDialog,
    setPTPType,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    item
  } = props;

  console.log(item, "item")

  const [bills, setBills] = useState([]);
  const [challans, setChallans] = useState([]);
  const [purchases, setPurchases] = useState([]);
  const [debits, setDebits] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);

  console.log(purchases, debits, "67")

  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const authToken = useSelector((state) => state.userReducer.authToken);

  const types = [
    { label: "Challan", value: "challan" },
    { label: "Bill", value: "bill" },
  ];

  // Fetch Bills
  const _getBills = async () => {
    try {
      const query = `&userId=${item._id}&startDate=${moment(startDate).format("DD-MM-YYYY")}&endDate=${moment(endDate).format("DD-MM-YYYY")}`;
      const res = await axios.get(GetAllBillsAPI(userInfo.entity) + query, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("billres", res.data)

      setBills(res.data.bills);
    } catch (err) {
      console.error("Error fetching bills:", err);
    }
  };

  // Fetch Challans
  const _getChallans = async () => {
    if (item.partyType === "purchase") {
      await Promise.all([_getPurchases(), _getDebits()]);
    }
    try {
      // Same as Ledger: all challans in date range (billed + unbilled)
      const query = `&userId=${item._id}&startDate=${moment(startDate).format("DD-MM-YYYY")}&endDate=${moment(endDate).format("DD-MM-YYYY")}`;
      const res = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("Challan API response:", res.data); // Debug log

      // Always set the state, even if empty, so we know the fetch completed
      if (res.data && res.data.challans) {
        console.log("Setting challans:", res.data.challans.length, "items");
        setChallans(res.data.challans.reverse());
      } else {
        console.warn("No challans in response or response structure is different:", res.data);
        setChallans([]);
      }
    } catch (err) {
      console.error("Error fetching challans:", err);
      setChallans([]); // Set empty array on error
    }
  };
  const _getPurchases = async () => {
    console.log("Fetching purchases")
    try {
      // Same as Ledger: all in date range (billed + unbilled)
      const query = `&userId=${item._id}&purchaseType=Challan&startDate=${moment(startDate).format("DD-MM-YYYY")}&endDate=${moment(endDate).format("DD-MM-YYYY")}`;
      const res = await axios.get(GetAllPurchasesAPI(userInfo.entity) + query, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("Purchases API response:", res.data, "Query:", query);

      // Always set the state, even if empty
      if (res.data && res.data.purchases) {
        console.log("Setting purchases:", res.data.purchases.length, "items");
        setPurchases(res.data.purchases.reverse());
      } else {
        console.warn("No purchases in response");
        setPurchases([]);
      }
    } catch (err) {
      console.error("Error fetching purchases:", err);
      setPurchases([]); // Set empty array on error
    }
  };

  const _getDebits = async () => {
    try {
      // Same as Ledger: all in date range (billed + unbilled)
      const query = `&userId=${item._id}&purchaseType=Challan&startDate=${moment(startDate).format("DD-MM-YYYY")}&endDate=${moment(endDate).format("DD-MM-YYYY")}`;
      const res = await axios.get(GetAllDebitsAPI(userInfo.entity) + query, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("Debits API response:", res.data);

      // Always set the state, even if empty
      if (res.data && res.data.debits) {
        console.log("Setting debits:", res.data.debits.length, "items");
        setDebits(res.data.debits.reverse());
      } else {
        console.warn("No debits in response");
        setDebits([]);
      }
    } catch (err) {
      console.error("Error fetching debits:", err);
      setDebits([]); // Set empty array on error
    }
  };

  // Generate Bill PDF
  const _generateBill = async () => {
    setIsGenerating(true);
    try {
      const htmlData = { bills, startDate, endDate };
      const htmlTemplate = pointToPointBillTemplate(htmlData);
      const options = { orientation: "p", unit: "pt", format: "a4", putOnlyUsedFonts: true, margin: [18, 18, 18, 18] };
      await htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
        const preBlob = dataURItoBlob(dataString);
        window.open(URL.createObjectURL(preBlob));
      });
      return true; // Success
    } catch (e) {
      console.error("Error generating bill:", e);
      toast.error("Error generating bill. Please try again.");
      return false; // Error
    } finally {
      setIsGenerating(false);
    }
  };

  // // Generate Challan PDF
  // const _generateChallan = async () => {
  //   try {
  //     if(challans.length<1){
  //       return toast.error("No Challans Found.")
  //     }
  //     if(item.partyType === "purchase"){
  //       console.log("yessing")
  //       let challanss = [...purchases, ...debits];
  //     }
  //     const htmlData = { challans ? challans : challanss , challanDate: moment().format("DD-MM-YYYY"), startDate, endDate };
  //     const htmlTemplate = pointToPointTemplate(htmlData);
  //     const options = { orientation: "p", unit: "pt", format: [850, 1066], putOnlyUsedFonts: true };
  //     await htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
  //       const preBlob = dataURItoBlob(dataString);
  //       window.open(URL.createObjectURL(preBlob));
  //     });
  //   } catch (e) {
  //     console.error("Error generating challan:", e);
  //   }
  // };
  const _generateChallan = async () => {
    setIsGenerating(true);
    try {
      console.log("Generate Challan - Dates:", startDate, endDate);
      console.log("Generate Challan - Party type:", item.partyType);

      // Fetch fresh data before generating to avoid race conditions
      console.log("Fetching fresh challan data before generation...");
      let fetchedChallans = [];
      let fetchedDebits = [];

      // Fetch challans
      try {
        // Same as Ledger: all challans in date range
        const query = `&userId=${item._id}&startDate=${moment(startDate).format("DD-MM-YYYY")}&endDate=${moment(endDate).format("DD-MM-YYYY")}`;
        const res = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        if (res.data && res.data.challans) {
          fetchedChallans = res.data.challans.reverse();
          console.log("Fetched challans:", fetchedChallans.length, "items");
        }
      } catch (err) {
        console.error("Error fetching challans:", err);
      }

      // Fetch debits if purchase type
      if (item.partyType === "purchase") {
        try {
          // Same as Ledger: all in date range
          const debitQuery = `&userId=${item._id}&purchaseType=Challan&startDate=${moment(startDate).format("DD-MM-YYYY")}&endDate=${moment(endDate).format("DD-MM-YYYY")}`;
          const debitRes = await axios.get(GetAllDebitsAPI(userInfo.entity) + debitQuery, {
            headers: { Authorization: `Bearer ${authToken}` },
          });
          if (debitRes.data && debitRes.data.debits) {
            fetchedDebits = debitRes.data.debits.reverse();
            console.log("Fetched debits:", fetchedDebits.length, "items");
          }
        } catch (err) {
          console.error("Error fetching debits:", err);
        }
      }

      // Combine data based on party type
      let challanss = fetchedChallans; // Default to challans
      if (item.partyType === "purchase") {
        console.log("Party type is purchase, combining challans and debits");
        challanss = [...fetchedChallans, ...fetchedDebits];
        console.log("Combined challans + debits:", challanss.length, "items (challans:", fetchedChallans.length, "debits:", fetchedDebits.length, ")");
      }

      console.log("Final challanss to generate:", challanss.length, "items");

      if (challanss.length < 1) {
        console.warn("No challans found to generate PDF");
        toast.error("No Challans Found.");
        return false; // No data
      }

      const htmlData = {
        challans: challanss,
        challanDate: moment().format("DD-MM-YYYY"),
        startDate,
        endDate
      };

      const htmlTemplate = pointToPointTemplate(htmlData);
      const options = {
        orientation: "p",
        unit: "pt",
        format: [850, 1066],
        putOnlyUsedFonts: true
      };

      await htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
        const preBlob = dataURItoBlob(dataString);
        window.open(URL.createObjectURL(preBlob));
      });

      return true; // Success
    } catch (e) {
      console.error("Error generating challan:", e);
      toast.error("Error generating challan. Please try again.");
      return false; // Error
    } finally {
      setIsGenerating(false);
    }
  };


  // Fetch data based on the selected type
  useEffect(() => {
    if (startDate && endDate && item) {
      if (PTPType === "challan") {
        _getChallans();
      } else {
        _getBills();
      }
    }
  }, [startDate, endDate, PTPType, item]);


  return (
    <Dialog
      onClose={() => setOpenPTPTypeSelectionDialog(false)}
      open={openPTPTypeSelectionDialog}
      fullScreen={fullScreen}
    >
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Select Type</h4>
            </CardHeader>
            <CardBody>
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel id="select-type-label">Type</InputLabel>
                <Select
                  labelId="select-type-label"
                  value={PTPType}
                  onChange={(e) => setPTPType(e.target.value)}
                >
                  {types.map(({ label, value }) => (
                    <MenuItem key={value} value={value}>{label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <GridItem xs={12} style={{ marginTop: 20 }}>
                  <DatePicker
                    label="Start Date"
                    fullWidth
                    value={startDate}
                    onChange={setStartDate}
                  />
                </GridItem>
                <GridItem xs={12} style={{ marginTop: 20 }}>
                  <DatePicker
                    label="End Date"
                    fullWidth
                    value={endDate}
                    onChange={setEndDate}
                  />
                </GridItem>
              </MuiPickersUtilsProvider>
            </CardBody>
            <CardFooter style={{ justifyContent: "center" }}>
              <Button
                color="primary"
                disabled={isGenerating}
                onClick={async () => {
                  let success = false;
                  if (PTPType === "bill") {
                    success = await _generateBill();
                  } else {
                    success = await _generateChallan();
                  }
                  // Close dialog only on successful generation
                  if (success) {
                    setOpenPTPTypeSelectionDialog(false);
                  }
                }}
              >
                {isGenerating ? "Generating..." : "Submit"}
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}
